import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name } from './symbols'
import type { FreemiumBannerEditorConfig, FreemiumBannerHandlers } from './types'
import {
	CarmiInstance,
	IStructureAPI,
	StructureAPI,
	IPageDidMountHandler,
	EditorFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'

const addFreemiumBannerToShellStructure = (structureApi: IStructureAPI, shouldShowFreemiumBanner: boolean) => {
	const mainMfCompId = 'main_MF'
	const wixAdsCompId = 'WIX_ADS'
	const mainMfComp = structureApi.get(mainMfCompId)
	if (!mainMfComp) {
		return
	}
	if (!shouldShowFreemiumBanner) {
		structureApi.removeComponentFromParent(mainMfCompId, wixAdsCompId)
		return
	}

	// make sure WIX_ADS is not already in mainMf before adding it
	if (!mainMfComp.components.includes(wixAdsCompId)) {
		structureApi.addComponentToParent(mainMfCompId, wixAdsCompId, 1)
	}
}

const freemiumBannerFactory = ({
	freemiumBanner,
}: DSCarmi): IModelUpdatesHandlersImplementor<FreemiumBannerHandlers> => {
	return {
		featureName: name,
		handlers: {
			updateShouldShowFreemiumBanner: ({ shouldShowFreemiumBanner }) => {
				freemiumBanner.setShouldShowFreemiumBanner(shouldShowFreemiumBanner)
			},
		},
	}
}

const addFreemiumBannerAfterPageMount = (
	structureApi: IStructureAPI,
	editorConfig: FreemiumBannerEditorConfig
): IPageDidMountHandler => {
	return {
		pageDidMount: () => {
			addFreemiumBannerToShellStructure(structureApi, editorConfig.shouldRenderFreemiumBanner)
		},
	}
}

export const FreemiumBannerSideEffect = withDependencies([CarmiInstance], freemiumBannerFactory)

export const FreemiumBannerPageDidMount = withDependencies(
	[StructureAPI, named(EditorFeatureConfigSymbol, name)],
	addFreemiumBannerAfterPageMount
)
